import { Round as ChevronRight } from '@manomano-internal/tamagoshi-icons/esm/material/ChevronRight';
import classnames from 'classnames';
import dynamic from 'next/dynamic';
import { useEffect, useState, type FunctionComponent } from 'react';
import { translate } from '@/core/localization/translate';
import { Text } from '@/core/tamagoshi/Text/Text';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { SectionButton } from '@/domains/core/tamagoshiTailwind/components/SectionButton/SectionButton';
import { Button } from '@/domains/core/tamagoshiv2/components/Button/Button';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import styles from './VariantPicker.module.scss';
export const {
  modalModelPickerOptions
} = translate({
  "modalModelPickerOptions": "options"
});
const ModalModelPicker = dynamic(() => import('@/productDiscovery/ProductPage/common/modules/VariantPicker/VariantPickerModal').then(mod => mod.VariantPickerModal), {
  ssr: false
});
export interface ModalModelPickerProps {
  className?: string;
}
export const VariantPickerCTA: FunctionComponent<ModalModelPickerProps> = ({
  className
}) => {
  const [isProductPageRevampEnabled] = useBooleanFlags([StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP]);
  const [isVisible, setIsVisible] = useState(false);
  const {
    totalModels,
    modelId,
    models,
    media
  } = useDetail();
  const onPickerClick = () => {
    setIsVisible(true);
  };
  const onClose = () => {
    setIsVisible(false);
  };
  useEffect(() => {
    setIsVisible(false);
  }, [modelId]);
  if (!models || totalModels < 2) return null;
  const currentModel = models.find(m => m.modelId === modelId);
  if (isProductPageRevampEnabled) return <>
        {isVisible && <ModalModelPicker onClose={onClose} />}

        <div className="border-t border-foundation-primary">
          <SectionButton title={`${totalModels} ${modalModelPickerOptions}`} onClick={onPickerClick} hoverDisabled imageSrc={media?.[0]?.thumbnailUrl} imageAlt={media?.[0]?.title || ''} variant="L" compact />
        </div>
      </>;
  return <>
      <div className={classnames(styles.pickerContainer, className)}>
        <Text className={styles.ctaLabel} weight="semiBold">
          {`${totalModels} ${modalModelPickerOptions}`}
        </Text>
        <Button content={{
        label: currentModel?.description || 'Select',
        icon: () => <ChevronRight />
      }} className={styles.pickerButton} iconPosition="right" onClick={onPickerClick} size="L" type="tertiary" width="fillContainer" />
      </div>
      {isVisible && <ModalModelPicker onClose={onClose} />}
    </>;
};
VariantPickerCTA.displayName = 'ModalModelPicker';